import classnames from "classnames";
import { FC, ReactNode } from "react";

export type BadgeClassNames =
  | "badge--warning"
  | "badge--warning-2"
  | "badge--success"
  | "badge--danger"
  | "badge--info"
  | "badge--neutral";

interface BadgeProps {
  badgeType: BadgeClassNames;
  className?: string;
  children: ReactNode;
}

export const Badge: FC<BadgeProps> = (props: BadgeProps) => {
  return (
    <span className={classnames("badge", props.badgeType, 
    { [props.className]: !!props.className })}>
      {props.children}
    </span>
  );
};
